module.exports = __webpack_public_path__ + "img/about-ch1-coresectors-urbanenergy.7bced986.svg";